import { useSelectedDealer } from "components";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { getChecklistById } from "modules/ChecklistsDashboard/util";
import { ApiInstance } from "utils/Api";

import type { ChecklistID, DealerLocationID } from "models";

type AttachChecklistToLocationPayload = {
  checklist_id: ChecklistID;
  dealer_location_id: DealerLocationID;
};

export const useAttachChecklistToLocationMutation = () => {
  const { selectedDealer } = useSelectedDealer();

  return useTypedMutation<AttachChecklistToLocationPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/checklists/location/attach", payload, ENV.dealerBaseURL);
    },
    onSuccess: ({ checklist_id, dealer_location_id }) => {
      const locationChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.locationChecklists(dealer_location_id)) ?? [];
      if (locationChecklists.some(lc => lc.id === checklist_id)) return;

      const checklist = getChecklistById(checklist_id, selectedDealer?.id);
      if (!checklist) return;

      typedQueryClient.setQueryData(ChecklistsDashboardQueryKeys.locationChecklists(dealer_location_id), [
        { ...checklist, display_order: 1 },
        ...locationChecklists.map(lc => ({ ...lc, display_order: (lc.display_order ?? 0) + 1 }))
      ]);
    }
  });
};
